// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
//import './assets/css/theme-green/index.css';       // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import Viewer from 'v-viewer'
import router from './router'
import 'viewerjs/dist/viewer.css'
import './assets/css/contentCss.css'
Vue.use(Viewer, {
  defaultOptions: {
      zIndex: 9999
  }
})
Vue.use(ElementUI, {
  size: 'small'
});

// import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
// import 'vue-directive-image-previewer/dist/assets/style.css'
// Vue.use(VueDirectiveImagePreviewer) 

// // 引用API文件
// import api from './api/index'
// // 将API方法绑定到全局
// Vue.prototype.$api = api

Vue.config.productionTip = false

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {

  const user=localStorage.getItem("user");
  if (user==null && to.path !== '/login') {
      next('/login');
  }
  //  else if (to.meta.permission) {
  //      var path=to.path.replace("/","");
  //     rights.indexOf(path)!=-1 ? next() : next('/403');
  // } 
  else {
    next();
}
})

//定义路由

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js